import React from "react";
import "./TitleWrapper.scss";

const TitleWrapper = ({ children, title, wrapperButton }) => {
  return (
    <>
      <div className="col-12 wrapper-title-sec px-0">
        <h2 className="wrapper-title">{title}</h2>
        <h4 className="wrapper-btn">{wrapperButton && wrapperButton}</h4>
      </div>
      <div className="col-12 py-2 px-0">
        <div className="row">{children}</div>
      </div>
    </>
  );
};

export default TitleWrapper;
